import { AsyncField, Field, useFormContext } from '@oscar/form';
import { DatePicker } from '@oscar/theme';
import { Col, Icon, Input, Row, Select } from '@oscar/theme';
import { DatePickerPopulate, TextField } from 'common/components';
import { FORMAT_DATE } from 'common/constants';
import { APIS } from 'common/constants/endpoints';
import { debounce } from 'lodash';
import moment from 'moment';
import React, { useState } from 'react';
import { StatusInstance } from 'views/pages/create-instrulation/hooks/useStatus';
const { Option } = Select;

export const FinalHandOver = ({
  statusRequest: { state, status },
}: {
  statusRequest: StatusInstance;
}) => {
  const [inspectedBy, setInspectedBy] = useState('');

  const disableDate = (current: any) => {
    return current && current.valueOf() < moment().subtract(1, 'd');
  };

  return (
    <div className="removal-detail">
      <Row gutter={[20, 20]}>
        <Col span={12}>
          {state === 'EDIT' ? (
            <>
              <AsyncField
                name={'searchAllUser'}
                requests={[
                  {
                    name: 'searchUser',
                    url: APIS.QAQC_SEARCH_USER,
                    method: 'POST',
                    nextData: (nextProps: any) => {
                      return {
                        isSearchAll: true,
                        name: nextProps?.customData?.textSearch || '',
                      };
                    },
                  },
                ]}
              >
                {(inspectedByProps: any) => {
                  const options = inspectedByProps?.data?.searchUser || [];
                  const textSearch =
                    inspectedByProps?.requests?.[0]?.params?.name || '';
                  return (
                    <>
                      <p>Executive-in-charge</p>
                      <Field
                        name={['proposalBillingDetail', 'executiveInCharge']}
                      >
                        <Select
                          value={inspectedBy}
                          showSearch
                          placeholder="Executive-in-charge"
                          allowClear
                          filterOption={false}
                          onSearch={debounce(value => {
                            inspectedByProps.reloadData({
                              textSearch: value,
                            });
                          }, 300)}
                          style={{ width: '100%' }}
                          onChange={(value: any) => setInspectedBy(value)}
                        >
                          {options.map?.((item: any) => {
                            return (
                              <Option value={item.id} key={item.id}>
                                {item?.name}
                              </Option>
                            );
                          })}
                        </Select>
                      </Field>
                    </>
                  );
                }}
              </AsyncField>
            </>
          ) : (
            <Field name={['proposalBillingDetail', 'executiveInChargeName']}>
              <TextField label="Executive-in-charge" />
            </Field>
          )}
        </Col>
        <Col span={12}>
          {state === 'EDIT' ? (
            <>
              <p>Date</p>
              <Field name={['proposalBillingDetail', 'date']}>
                <DatePickerPopulate
                  format={FORMAT_DATE.SHORT_MONTH_DATE}
                  disabledDate={disableDate}
                />
              </Field>
            </>
          ) : (
            <Field name={['proposalBillingDetail', 'date']}>
              <TextField
                label="Date"
                isDate
                formartDate={FORMAT_DATE.SHORT_MONTH_DATE}
              />
            </Field>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default FinalHandOver;
